export default "__VITE_ASSET__Bgg6HDp2__"